import { queryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { SecurityInsightsAttackPathDetailsResponse } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';
import { isE2E } from '@cast/utils';

const SECURITY_ATTACK_PATH_DETAILS_QUERY_KEY = 'security-attack-path-details';

const getAttackPathDetailsQueryKey = (id: string) =>
  [SECURITY_ATTACK_PATH_DETAILS_QUERY_KEY, id] as const;

const getAttackPathDetailsQueryOptions = (id: string) =>
  queryOptions<SecurityInsightsAttackPathDetailsResponse, AxiosError>({
    queryKey: getAttackPathDetailsQueryKey(id),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getAttackPathDetails({
        id,
      });
      return data;
    },
    retry(failureCount, error) {
      if (error?.response?.status === 404) {
        return false;
      }
      return !isE2E() && failureCount < 3;
    },
  });

export const useAttackPathDetailsQuery = (id: string) => {
  const {
    isLoading,
    data: attackPathDetails,
    error,
    refetch,
  } = useQuery(getAttackPathDetailsQueryOptions(id));

  return {
    isLoading,
    attackPathDetails,
    error,
    refetch,
  };
};
